/**
 * @fileoverview Home page sections for the Finch & Dudley Dental site.
 *
 * Note:
 * - This stays as the single-page, anchor-link experience.
 * - Blog on the home page is a 3-post teaser strip; full blog is at `/blog`.
 */

import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Team from "../components/Team";
import Gallery from "../components/Gallery";
import Blog from "../components/Blog";
import Contact from "../components/Contact";

const HomePage = () => {
  return (
    <>
      <Hero />
      <Services />
      <About />
      <Team />
      <Gallery />
      <Blog variant="teaser" />
      <Contact />
    </>
  );
};

export default HomePage;

